module.exports = __webpack_public_path__ + "img/Manu_A_.6094feee.jpg";